import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";

import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";

/**
 * material-dashboard-pro-react의 CustomInput에 redux 정보와 input의 type 정보 추가 
 */
function CustomInput({ ...props }) {
    const {
        classes,
        color,
        formControlProps,
        labelText,
        id,
        labelProps,
        inputProps,
        error,
        white,
        inputRootCustomClasses,
        success,
        helpText,
        type,
        input,
        meta,
        size,
        textAlign
    } = props;
    const isError = error || (meta && meta.touched && meta.error ? true : false);
    const errorMsg = (meta && meta.touched && meta.error) || helpText;

    const labelClasses = classNames({
        [classes[size]]: size,
        [classes.labelRoot]: true,
        [classes.labelRootError]: isError,
        [classes.labelRootSuccess]: success && !isError
    });
    const underlineClasses = classNames({
        [classes.underlineError]: isError,
        [classes.underlineSuccess]: success && !isError,
        [classes.underline]: true,
        [classes[color+"Underline"]]: !isError,
        [classes.whiteUnderline]: white
    });
    const marginTop = classNames({
        [inputRootCustomClasses]: inputRootCustomClasses !== undefined
    });
    const inputClasses = classNames({
        [classes[size]]: size,
        [classes.input]: true,
        [classes.whiteInput]: white
    });
    var formControlClasses;
    formControlClasses = classNames(formControlProps ? formControlProps.className : null, {
        [classes[size]]: size,
        [classes.formControl]: labelText !== undefined,
        [classes.formControlWithoutLabel]: labelText === undefined
    })

    var helpTextClasses = classNames({
        [classes[size]]: size,
        [classes.helpText]: true,
        [classes.labelRootError]: isError,
        [classes.labelRootSuccess]: success && !isError
    });

    const newId = input && input.name ? input.name : id;
    return (
        // 부라우저마다 먼저 먹는 style이 달라져서 위치를 서로 변경
        //<FormControl {...formControlProps} className={formControlClasses}>
        <FormControl className={formControlClasses} {...formControlProps}>
            {labelText !== undefined ? (
                <InputLabel
                    className={labelClasses}
                    htmlFor={newId}
                    {...labelProps}
                >
                {labelText}
                </InputLabel>
            ) : null}
            <Input
                classes={{
                    input: inputClasses,
                    root: marginTop,
                    disabled: classes.disabled,
                    underline: underlineClasses
                }}
                id={newId}
                type={type ? type : "text"}
                inputProps={{ "style": {"textAlign": textAlign} }}
                {...inputProps}
                {...input}
            />
            { errorMsg && 
                <FormHelperText id={newId + "-text"} className={helpTextClasses}>
                    {errorMsg}
                </FormHelperText>
            }
        </FormControl>
    );
}

CustomInput.defaultProps = {
    size: "sm",
    color: "primary",
    textAlign: "left"
};

CustomInput.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "danger",
        "darkblue"
    ]),
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    inputRootCustomClasses: PropTypes.string,
    error: PropTypes.bool,
    success: PropTypes.bool,
    white: PropTypes.bool,
    helpText: PropTypes.node,
    size: PropTypes.oneOf(["sm", "lg"]),
    textAlign: PropTypes.string
};

export default withStyles(customInputStyle)(CustomInput);
